import { Box, Button, Heading, Text } from '../../../mads';
import { useI18n } from '../../I18n';

import { StyleSheet } from 'react-native';

export type ErrorPageProps = {
    onRetry?: () => void;
};

export const ErrorPage = (props: ErrorPageProps) => {
    const { gettext } = useI18n();
    return (
        <Box sx={styles.container}>
            <Heading sx={styles.heading}>{gettext('Something went wrong on our end')}</Heading>
            <Text level={3} sx={styles.description}>
                {gettext('We’re working to fix it. Please try again later.')}
            </Text>
            {props.onRetry && <Button onPress={props.onRetry}>{gettext('Retry')}</Button>}
        </Box>
    );
};

const styles = StyleSheet.create({
    container: {
        margin: 16,
        textAlign: 'center',
    },
    heading: {
        textAlign: 'center',
        marginBottom: 8,
    },
    description: { textAlign: 'center', marginBottom: 32 },
});
